import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const V2FinancialAccountsTransactionsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "v2FinancialAccountsTransactions" */
      '../../../components/MoneyManagement/V2FinancialAccountsTransactions'
    ),
  releaseState: 'internal',
  enabledKey: 'internal',
  teamOwner: 'platform-surfaces',
  sentryTeam: 'platform_surfaces_embedded',
  description: 'Displays the list of transactions for a V2 financial account.',
  friendlyName: 'V2 financial accounts transactions',
  enableV2APIToken: true,
};
